import { render, staticRenderFns } from "./FormDivider.vue?vue&type=template&id=500d0276&scoped=true&lang=pug"
import script from "./FormDivider.vue?vue&type=script&lang=js"
export * from "./FormDivider.vue?vue&type=script&lang=js"
import style0 from "./FormDivider.vue?vue&type=style&index=0&id=500d0276&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "500d0276",
  null
  
)

export default component.exports